import * as yup from "yup";

export type FormValues = {
  currentPassword: string;
  newPassword: string;
};

export const validationSchema = yup.object({
  currentPassword: yup
    .string()
    .required("Вкажіть 'Старий пароль'")
    .min(6, "Пароль має містити більше 6-ти символів"),
  newPassword: yup
    .string()
    .required("Вкажіть 'Новий пароль'")
    .min(6, "Пароль має містити більше 6-ти символів"),
});
